import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from './index';

/**
 * Fires a GA4 pageview on every client-side route change. Renders nothing.
 * Must be rendered inside the Router (it relies on useLocation).
 */
const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);

  return null;
};

export default RouteChangeTracker;
